import React, { useMemo } from 'react';
import { getGroupRegistrantSummary } from '../../../utils/groupRegistrantSummary';

const GroupRegistrantSummary = ({ registrants, groupName }) => {
    const summary = useMemo(() => getGroupRegistrantSummary(registrants), [registrants]);
    return (
        <div className="sam-group-summary">
            <table aria-label={`Registrant summary for ${groupName}`}>
                <thead>
                    <tr>
                        <th scope="col">Competition category</th>
                        {summary.events.map(({ eventId }) => <th scope="col" key={eventId}>{eventId}</th>)}
                        <th scope="col">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {summary.categories.length ? summary.categories.map(category => (
                        <tr key={category.label}>
                            <th scope="row">{category.label}</th>
                            {summary.events.map(({ eventId }) => <td key={eventId}>{category.events[eventId] || 0}</td>)}
                            <td>{category.total}</td>
                        </tr>
                    )) : <tr><td colSpan={summary.events.length + 2}>No registrants assigned</td></tr>}
                </tbody>
                <tfoot>
                    <tr>
                        <th scope="row">Total registrants</th>
                        {summary.events.map(({ eventId, count }) => <td key={eventId}>{count}</td>)}
                        <td>{summary.total}</td>
                    </tr>
                    <tr>
                        <th scope="row" title="Unique teacher names, ignoring case and surrounding spaces; blank names are excluded. Each teacher counts once in the group total, even across events.">Total teachers</th>
                        {summary.events.map(({ eventId, teacherCount }) => <td key={eventId}>{teacherCount}</td>)}
                        <td>{summary.totalTeachers}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default GroupRegistrantSummary;
